// extracted by mini-css-extract-plugin
export default {"description":"style_description__vqv3u","fade-in":"style_fade-in__pzx6U","top":"style_top__lhkS4","image":"style_image__UfLaH"};